/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function DocumentFolderFromJSON(json) {
    return DocumentFolderFromJSONTyped(json, false);
}
export function DocumentFolderFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        name: json['name'],
        documentsCount: json['documents_count'],
        createdAt: json['created_at'],
        updatedAt: json['updated_at']
    };
}
export function DocumentFolderToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        name: value.name,
        documents_count: value.documentsCount,
        created_at: value.createdAt,
        updated_at: value.updatedAt
    };
}
